var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},_vm._l((_vm.games),function(game){return _c('game',{key:game,attrs:{"game":game}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }